import { Box, Button, Stack, Typography, styled } from '@lingoda/ui';
import { Grid } from '@lingoda/ui/layout/GridNext';
import { trans } from '@lingoda/i18n';
import { loginPath } from '@lingoda/router';
import WaveSvg from './assets/wave.svg?component';
import { WaveWrapper, Wrapper } from './LayoutWrappers';
import { SectionLinks } from './SectionLinks';
import { CharactersBubbles } from './CharactersBubbles';
import type { ErrorLayoutProps } from './LayoutWrappers';

export const UnAuthenticatedLayout = ({ errorType, customMessage }: ErrorLayoutProps) => {
    return (
        <Wrapper>
            <WaveWrapper top={{ xs: '-25%', md: '-50%' }}>
                <WaveSvg />
            </WaveWrapper>

            <Stack width="100%" py={{ xs: 2, md: 5 }} px={{ xs: 3, md: 6 }} zIndex={2}>
                <Stack spacing={{ xs: 1, md: 2 }} mb={2}>
                    <Typography variant="h2">
                        {customMessage || trans('page-not-exists', {}, 'public-common')}
                    </Typography>
                    <Typography variant="subtitle1">
                        {trans('page-not-exists-links', {}, 'public-common')}
                    </Typography>
                </Stack>

                <Grid container spacing={2}>
                    <Grid xs={12} md={4}>
                        <SectionLinks mb={2} />
                        <Button color="primary" variant="contained" href={loginPath()}>
                            {trans('btn-back-to-login', {}, 'public-common')}
                        </Button>
                    </Grid>

                    <Grid xs={12} md={8}>
                        <CharactersContainer>
                            <CharactersBubbles errorType={errorType} />
                        </CharactersContainer>
                    </Grid>
                </Grid>
            </Stack>
        </Wrapper>
    );
};

const CharactersContainer = styled(Box)(({ theme }) => ({
    position: 'relative',
    zIndex: 2,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: 400,

    [theme.breakpoints.up('md')]: {
        transform: 'scale(0.7) translate(-20%, 0)',
    },
}));
